import { render, staticRenderFns } from "./CatalogoDetailDrawer.vue?vue&type=template&id=c5589602&scoped=true&"
import script from "./CatalogoDetailDrawer.vue?vue&type=script&lang=js&"
export * from "./CatalogoDetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoDetailDrawer.vue?vue&type=style&index=0&id=c5589602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5589602",
  null
  
)

export default component.exports